export default (data: any) => {
  if (!data) {
    return null
  }
  return { id: data?.sys?.id || '', name: data?.internalName || '', theme: data?.theme?.toLowerCase() || '' }
}
